import { render, staticRenderFns } from "./servicesProduct1.vue?vue&type=template&id=fed11da0&scoped=true"
import script from "./servicesProduct1.vue?vue&type=script&lang=js"
export * from "./servicesProduct1.vue?vue&type=script&lang=js"
import style0 from "./servicesProduct1.vue?vue&type=style&index=0&id=fed11da0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed11da0",
  null
  
)

export default component.exports